// src/apiConfig.js
export const API_URL = 'https://greenmark.com.sg/api/courses.php';
export const REGISTER_URL = 'https://greenmark.com.sg/api/register.php';
export const COMPANY_URL = 'https://greenmark.com.sg/api/company.php';
export const STAFF_URL = 'https://greenmark.com.sg/api/staff.php';

// If you need to use a local API during development, uncomment one of these instead:
// export const API_URL = 'http://localhost/api/courses.php';
// export const API_URL = 'http://127.0.0.1/api/courses.php';
// export const API_URL = 'http://localhost/courses.php';
